var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 14H16.3333V16.3333H18.6667M18.6667 9.33333H16.3333V11.6667H18.6667M21 18.6667H11.6667V16.3333H14V14H11.6667V11.6667H14V9.33333H11.6667V7H21M9.33333 4.66667H7V2.33333H9.33333M9.33333 9.33333H7V7H9.33333M9.33333 14H7V11.6667H9.33333M9.33333 18.6667H7V16.3333H9.33333M4.66667 4.66667H2.33333V2.33333H4.66667M4.66667 9.33333H2.33333V7H4.66667M4.66667 14H2.33333V11.6667H4.66667M4.66667 18.6667H2.33333V16.3333H4.66667M11.6667 4.66667V0H0V21H23.3333V4.66667H11.6667Z",
    fill: "#566071"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIcon);
export default __webpack_public_path__ + "static/media/brand-icon.9b17b53b7170d6033b4ec1a7d4cd916d.svg";
export { ForwardRef as ReactComponent };